import React, { useEffect, useRef, useState } from 'react';
import {
  CartProduct, CartService, IProductMetadata, IProductMetadataError,
} from '../../../services';
import { AdobeTracking } from '../../../tracking';

type CartRowProps = IProductMetadata
& IProductMetadataError
& CartProduct
& { disableUpdates?: boolean; slot?: string }

const isProductError = (el: CartRowProps): boolean => el.response?.length > 0;

const options = JSON.stringify(
  Array.from({ length: 20 }, (_, i) => ({ label: i + 1, value: i + 1 })),
);

export const CartRow = (props: CartRowProps): JSX.Element => {
  if (isProductError(props)) {
    CartService.removeFromCart(props.productMetadataPageUniqueId);
    return null;
  }

  const { productMetadataPageUniqueId: id, slot, disableUpdates } = props;
  const { name, price, underline } = props.content;
  const inputElement = useRef(null);
  const [selected, setSelected] = useState(props.quantity - 1);

  const updatedData = {
    currency: 'EUR',
    items: [{
      item_id: id,
      item_name: name,
      currency: 'EUR',
      discount: '',
      item_brand: 'Roche',
      item_category: 'Product',
      item_variant: '',
      price,
      quantity: props.quantity,
    }],
  };

  useEffect(() => {
    if (disableUpdates) {
      return () => {};
    }
    const updateQuantity = (e: CustomEvent) => {
      if (!e.detail?.value?.value) {
        inputElement.current.shadowRoot.querySelector('select').selected = '0';
      }
      const value = parseInt(e.detail?.value?.value, 10);
      const parsedValue = (value < 1 || Number.isNaN(value)) ? 1 : value;
      setSelected(parsedValue - 1);
      CartService.updateQuantity(id, parsedValue);
      window.dispatchEvent(new CustomEvent(CartService.cartUpdateEvent));
    };
    inputElement?.current?.addEventListener('rocheDropdownChange', updateQuantity);

    return () => {
      inputElement?.current?.removeEventListener('rocheDropdownChange', updateQuantity);
    };
  }, []);

  return (
    <roche-cart-row
      slot={slot}
      name={name}
      price={price}
      underline={underline}
      quantity={selected + 1}
    >
      <roche-dropdown
        slot="quantity"
        ref={inputElement}
        placeholder="Menge"
        selected={selected}
        options={options}
        disabled={disableUpdates}
      />
      {!disableUpdates
      && <roche-icon
        slot="remove"
        icon="trash"
        height="24px"
        onClick={() => {
          AdobeTracking(updatedData, 'scRemove');
          CartService.removeFromCart(id);
          window.dispatchEvent(new CustomEvent(CartService.cartUpdateEvent));
        }}
      />}
    </roche-cart-row>);
};
